import { getNewErrorsArray } from '../../../utils/formatters';
import { GeneralActionsNames } from '../general/general.actions';
import { ShippingCompaniesActionsNames } from './shippingCompanies.actions';
import { ShippingCompaniesAction, ShippingCompaniesState } from './type';

const initialState: ShippingCompaniesState = {
  isLoading: false,
  error: null,
  shippingCompanies: [],
};

const shippingCompaniesReducer = (
  state: ShippingCompaniesState = initialState,
  action: ShippingCompaniesAction
): ShippingCompaniesState => {
  switch (action.type) {
    case ShippingCompaniesActionsNames.GET_SHIPPING_COMPANIES.START:
    case ShippingCompaniesActionsNames.ADD_SHIPPING_COMPANY.START:
    case ShippingCompaniesActionsNames.UPDATE_SHIPPING_COMPANY.START:
    case ShippingCompaniesActionsNames.RELINK_SHIPPING_COMPANY_CLIENT.START:
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case ShippingCompaniesActionsNames.GET_SHIPPING_COMPANIES.FULFILLED:
      return {
        ...state,
        isLoading: false,
        shippingCompanies: action.payload,
      };
    case ShippingCompaniesActionsNames.ADD_SHIPPING_COMPANY.FULFILLED:
    case ShippingCompaniesActionsNames.UPDATE_SHIPPING_COMPANY.FULFILLED:
    case ShippingCompaniesActionsNames.RELINK_SHIPPING_COMPANY_CLIENT.FULFILLED:
      return {
        ...state,
        isLoading: false,
      };
    case ShippingCompaniesActionsNames.GET_SHIPPING_COMPANIES.REJECTED:
    case ShippingCompaniesActionsNames.ADD_SHIPPING_COMPANY.REJECTED:
    case ShippingCompaniesActionsNames.UPDATE_SHIPPING_COMPANY.REJECTED:
    case ShippingCompaniesActionsNames.RELINK_SHIPPING_COMPANY_CLIENT.REJECTED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case GeneralActionsNames.CLEAR_ERRORS.FULFILLED:
      return {
        ...state,
        error: getNewErrorsArray(state.error, action.payload),
      };
  }
  return state;
};

export default shippingCompaniesReducer;
